//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.GeometricConstraintDataManager.js";
import "../GeometricUtilities/GeometricUtilities.SplineExtensionBuilder.js";
import "../GeometricUtilities/GeometricUtilities.OrientXpressBuilder.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"CanUseOrientationTool",1,0],[1,"ConstraintManager",0,"Features.GeometricConstraintDataManager",0],[0,"ConstraintPlane",1,"CoordinateSystem",0],[0,"Curve",0,"Spline",0],[0,"Degree",1,0],[0,"DrawingPlane",1,"Plane",0],[0,"DrawingPlaneOption",1,0],[1,"Extender",0,"GeometricUtilities.SplineExtensionBuilder",0],[0,"HasPlaneConstraint",1,0],[0,"HasProportionalUpdate",1,0],[0,"InputCurveOption",1,0],[0,"IsAssociative",1,0],[0,"IsPeriodic",1,0],[0,"IsSingleSegment",1,0],[0,"MatchKnotsType",1,0],[0,"MovementMethod",1,0],[0,"MovementPlane",1,"Plane",0],[0,"MovementVector",1,"Direction",0],[1,"OrientExpress",0,"GeometricUtilities.OrientXpressBuilder",0],[0,"ProjectToGeometry",1,0],[0,"Type",1,0],[0,"WCSOption",1,0]],[[["numberOfKnots"],"GetKnots",{R_:{knots:""}},0,0],[["knots"],"SetKnots",{},1,0],[["numberOfParameters"],"GetParameters",{R_:{parameters:""}},0,0],[["parameters"],"SetParameters",{},1,0],[["spline"],"EditSpline",{},1,0],[["point"],"InsertKnot",{},1,0],[["afterIndex"],"InsertPole",{},1,0],[[],"Evaluate",{},0,0],[[],"UpdateOnConstraintPlane",{},0,0]],[]];
SPLM.Features.StudioSplineBuilderEx = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StudioSplineBuilderEx";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StudioSplineBuilderEx.Types = Object.freeze({
    "ThroughPoints" : "ThroughPoints", "ByPoles" : "ByPoles"});

SPLM.Features.StudioSplineBuilderEx.MatchKnotsTypes = Object.freeze({
    "None" : "None", "Cubic" : "Cubic", "General" : "General"});

SPLM.Features.StudioSplineBuilderEx.DrawingPlaneOptions = Object.freeze({
    "View" : "View", "XY" : "XY", "YZ" : "YZ", "XZ" : "XZ", "General" : "General"});

SPLM.Features.StudioSplineBuilderEx.InputCurveOptions = Object.freeze({
    "Keep" : "Keep", "Hide" : "Hide", "Delete" : "Delete"});

SPLM.Features.StudioSplineBuilderEx.MovementMethodType = Object.freeze({
    "WCS" : "WCS", "View" : "View", "Vector" : "Vector", "Plane" : "Plane", "Normal" : "Normal", "Polygon" : "Polygon"});

SPLM.Features.StudioSplineBuilderEx.WCSOptionType = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "YZ" : "YZ", "XZ" : "XZ", "XY" : "XY"});

export default SPLM;